import React from "react";
import cn from "classnames";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { IHorizontalCardsPanelVariants, ITextCard } from "../../../../types/common";
import { IContentfulRichTextResponse } from "../../../../types/IContentfulRichText";
import TextCard from "../../../TextCard";

import "./style.scss";

interface IHorizontalCardsPanelV1Props {
  title: IContentfulRichTextResponse;
  variant: IHorizontalCardsPanelVariants;
  cards: ITextCard[];
}

export const HorizontalCardsPanelV1 = ({ title, variant, cards }: IHorizontalCardsPanelV1Props) => {
  const cardsToRender = cards.map((card) => (
    <TextCard key={card.title} card={card} className={cn("horizontal-cards-panel-card", `horizontal-cards-panel-card--variant-${variant}`)} />
  ));

  return (
    <div className="horizontal-cards-panel">
      <div className="horizontal-cards-panel-content">
        <div className="horizontal-cards-panel-title">
          {title ? renderRichText(title) : null}
        </div>
        <div className={cn("horizontal-cards-panel-cards", `horizontal-cards-panel-cards--variant-${variant}`)}>
          {cardsToRender}
        </div>
      </div>
    </div>
  );
};
